import "./App.css";

import MyAdmin from "./components/Admin/index";

const App = () => <MyAdmin />;

export default App;
